import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import AsyncStorage from '@react-native-async-storage/async-storage';

// Importe les fichiers de traduction
import FR_Translation from './FR-translation.json';
import EN_Translation from './EN-translation.json';
import ES_Translation from './ES-translation.json';

// Importe les fichiers de traduction SEO
import FR_SEO from './seo-fr.json';
import EN_SEO from './seo-en.json';
import ES_SEO from './seo-es.json';

// Fonction pour détecter la langue du système ou celle stockée
const detectLanguage = async () => {
  try {
    const savedLanguage = await AsyncStorage.getItem('user-language');
    if (savedLanguage) {
      return savedLanguage; // Utilise la langue stockée
    }

    // Détection de la langue en fonction de la plateforme
    if (typeof navigator !== 'undefined') {
      // Environnement web
      return navigator.language.split('-')[0]; // Détecte la langue du navigateur
    }
  } catch (error) {
    console.error('Erreur lors de la détection de la langue:', error);
  }
  
  // Valeur par défaut en cas d'erreur ou pour l'environnement mobile
  return 'fr';
};

// Configuration de base de i18n
i18n
  .use(initReactI18next)
  .init({
    fallbackLng: 'fr', // Langue par défaut
    debug: process.env.NODE_ENV === 'development', // Active les logs uniquement en développement
    interpolation: {
      escapeValue: false, // Pas besoin d'échapper les valeurs HTML
    },
    // On commence avec une langue par défaut
    lng: 'fr',
    resources: {
      fr: {
        translation: { ...FR_Translation, ...FR_SEO }, // Traductions en français + SEO
      },
      en: {
        translation: { ...EN_Translation, ...EN_SEO }, // Traductions en anglais + SEO
      },
      es: {
        translation: { ...ES_Translation, ...ES_SEO }, // Traductions en espagnol + SEO
      },
    },
  });

// Mise à jour de la langue après l'initialisation
detectLanguage().then(detectedLang => {
  if (detectedLang && i18n.language !== detectedLang) {
    i18n.changeLanguage(detectedLang);
  }
});

export default i18n;